import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { InvoiceListTable } from "Invoices/Components/InvoiceListTable";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";

export const PartnerInvoicesPage = (): React.ReactNode => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout title={t(Resources.Invoices.Title)}>
      <InvoiceListTable />
    </AuthenticatedLayout>
  );
};
